module.exports = __webpack_public_path__ + "img/ic-add-hover.3915d7a3.svg";